import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants/routes';
import { useSuiteLoungeFlow } from '../../hooks/useSuiteLoungeFlow';

export const PasswordResetSentForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { withEntry } = useSuiteLoungeFlow();

  return (
    <section className="l-card">
      <div className="l-card__body">
        {/* メール送信完了メッセージ */}
        <div className="password-mail">
          <div className="password-mail__icon">
            <img
              src="/Common_Icon_Mail.png"
              alt={t('common.altText.emailSent')}
              className="password-mail__icon-img"
            />
          </div>
          <div className="password-mail__message">
            {t('passwordReset.sent.message')}
          </div>
        </div>

        {/* 注意ボックス */}
        <div className="l-notice-box l-mb30">
          <div className="l-notice-box__inner">
            <div className="l-notice-box__icon">
              <img
                src="/Common_Icon_Note.png"
                alt={t('common.altText.attention')}
                className="l-notice-box__icon-img"
              />
            </div>
            <div className="l-notice-box__text">
              {t('passwordReset.sent.infoTitle')}
              <br />
              {t('passwordReset.sent.infoSubtitle')}
            </div>
          </div>
          <div className="l-notice-box__list">
            <div className="l-notice-box__item">
              <div className="l-notice-box__item-marker">・</div>
              <div className="l-notice-box__item-text">
                {t('passwordReset.sent.infoItems.item1')}
              </div>
            </div>
            <div className="l-notice-box__item">
              <div className="l-notice-box__item-marker">・</div>
              <div className="l-notice-box__item-text">
                {t('passwordReset.sent.infoItems.item2')}
              </div>
            </div>
            <div className="l-notice-box__item l-notice-box__item--note">
              <div className="l-notice-box__item-marker">※</div>
              <div className="l-notice-box__item-text">
                {t('passwordReset.sent.infoItems.item3')}
              </div>
            </div>
          </div>
        </div>
        <div className="actions">
          <a
            className="link-button link-button--reserve-close"
            onClick={(e) => {
              e.preventDefault();
              navigate(withEntry(ROUTE_PATH.LOGIN));
            }}
            role="button"
          >
            {t('passwordReset.sent.closeButton')}
          </a>
        </div>
      </div>
    </section>
  );
};
